import type { FeatureManifest } from '../registry.js';

/**
 * Shop decor (D5): the sheet a decor spot opens in Decorate mode (ShopScene) with the owned
 * pieces that fit, take down and "Get more" (the store's Decor section). No flag and no API
 * gate: placing decor is an offline sync op like an upgrade.
 */
export default {
  id: 'decor',
  art: ['decor'],
  provides: ['decorSheet'],
  load: () => import('./index.js'),
} satisfies FeatureManifest;
